import { gql } from '@apollo/client';
import React from 'react';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import { withRouter } from '../../../services/withRoute';
import Modal from '../../components/modals';
import UploadLogoForm from '../../components/modals/workspace/logo';
import '../../../assets/scss/projectTable.scss';
import Dropzone from 'react-dropzone';
import { ReactComponent as UploadIcon } from '../../../assets/svg/upload-cloud.svg';
import { ReactComponent as Back } from '../../../assets/svg/arrow-back.svg';
import _ from 'lodash';
import Select from 'react-select';
import moment from 'moment';
import LoadingBar from '../../components/global/loadingBar';
var validator = require('validator');
const getEmployeeDetails2 = gql`
	query GetEmployee($getEmployeeId: ID!) {
		getEmployee(id: $getEmployeeId) {
			id
			aadharNumber
			dp_b2_300w_key
			dp_signed_url
			bankAccountDetails {
				IFSC
				accountNumber
				accountHolderName
				bankName
				branch
			}
			bloodGroup
			branch {
				_id
				branchId
			}
			createdAt
			createdBy
			currentAddress {
				city
				country
				district
				pinCode
				state
				street
			}
			deletedAt
			deletedBy
			department
			designation
			dob
			emergencyContact {
				name
				phoneNumber
				relation
			}
			employeeType
			firstName
			fullName
			gender
			id
			isDeleted
			joiningDate
			lastName
			monthlySalaryPreTax
			officeEmail
			officePhoneNumber
			panNumber
			permanentAddress {
				city
				country
				district
				pinCode
				state
				street
			}
			personalEmail
			personalPhoneNumber
			status
			updatedAt
			updatedBy
			workspaceId
		}
	}
`;
const getWorkSpaceOptions = gql`
	query VendorInfo($vendorId: String!) {
		vendorInfo(vendorId: $vendorId) {
			associatedTenants {
				workspaceId
			}
		}
	}
`;
const getBranchList = gql`
	query BranchesList {
		branchesList {
			id
			code
			branchId
			description
			address
			city
			state
		}
	}
`;
const getEmployeeDefaultfilters = gql`
	query EmployeeDefaultfilters {
		employeeDefaultfilters {
			designation
			department
			workspaceId
		}
	}
`;
const editEmployee = gql`
	mutation UpdateEmployee($updateEmployeeId: ID!, $updateEmployeeInput: UpdateEmployeeInput) {
		updateEmployee(id: $updateEmployeeId, updateEmployeeInput: $updateEmployeeInput) {
			firstName
			lastName
			gender
			dob
			bloodGroup
			aadharNumber
			panNumber
			joiningDate
			employeeType
			workspaceId
			department
			designation
			monthlySalaryPreTax
			branch {
				branchId
				_id
			}
			status
			personalEmail
			personalPhoneNumber
			officeEmail
			officePhoneNumber
			currentAddress {
				city
				country
				district
				pinCode
				state
				street
			}
			permanentAddress {
				city
				country
				district
				pinCode
				state
				street
			}
			emergencyContact {
				phoneNumber
				relation
				name
			}
			bankAccountDetails {
				IFSC
				accountNumber
			}
			createdAt
			createdBy
			deletedAt
			deletedBy
			id
			isDeleted
			fullName
			updatedAt
			updatedBy
		}
	}
`;
class EditEmployee extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			employeeDetails: {},
			message: '',
			employeeId: '',
			workspaceOptions: [],
			empTypeOptions: [
				{ value: 'SALARIED', label: 'Salaried' },
				{ value: 'CONSULTANT', label: 'Consultant' },
				{ value: 'INTERN', label: 'Intern' },
			],

			genderOptions: [
				{ value: 'MALE', label: 'Male' },
				{ value: 'FEMALE', label: 'Female' },
				{ value: 'OTHER', label: 'Other' },
			],
			employeeType: '',
			genderType: '',
			designations: [],
			departments: [],
			employeeTypeString: null,
			selectedBloodGroup: '',
			bloodGroupOptions: [
				{
					label: 'A+',
					value: 'A+',
				},
				{
					label: 'A-',
					value: 'A-',
				},
				{
					label: 'B+',
					value: 'B+',
				},
				{
					label: 'B-',
					value: 'B-',
				},
				{
					label: 'AB+',
					value: 'AB+',
				},
				{
					label: 'AB-',
					value: 'AB-',
				},
				{
					label: 'O+',
					value: 'O+',
				},
				{
					label: 'O-',
					value: 'O-',
				},
			],
			branchesOptions: [],
			selectedBranch: '',
			selectedDepartment: '',
			selectedDesignation: '',
			branchId: '',
			selectedDob: '',
			selectedJoiningDate: '',
			fnError: false,
			lnError: false,
			adError: false,
			panerror: false,
			curcityEr: false,
			curcountryEr: false,
			curDistrictEr: false,
			curPcEr: false,
			curStateEr: false,
			curStreetEr: false,
			percityEr: false,
			percountryEr: false,
			perDistrictEr: false,
			isemployeeloading: true,
			perPcEr: false,
			perStateEr: false,
			perStreetEr: false,
			emergencyNameError: false,
			bankifscEr: false,
			bankAccHolErr: false,
			bankAccNumberError: false,
			bankBranchError: false,
			bankNameError: false,
			selectedBrand: '',
			brandString: '',
			branchIdString: '',
			statusOptions: [
				{ value: 'ACTIVE', label: 'Active' },
				{ value: 'TERMINATED', label: 'Terminated' },
				{ value: 'ON_HOLD', label: 'On Hold' },
			],
			selectedStatus: '',
			statusString: null,
			firstName: null,
			lastName: null,
			gender: null,
			dob: null,

			bloodGroup: null,
			croppedFile: null,
			aadharNumber: null,
			panNumber: null,
			joiningDate: null,
			department: null,
			designation: null,
			monthlySalaryPreTax: null,
			personalPhoneNumber: null,
			personalEmail: null,
			officeEmail: null,
			officePhoneNumber: null,
			currentAddress: {
				city: null,
				country: null,
				district: null,
				pinCode: null,
				state: null,
				street: null,
			},
			permanentAddress: {
				city: null,
				country: null,
				district: null,
				pinCode: null,
				state: null,
				street: null,
			},
			emergencyContact: {
				name: null,
				phoneNumber: null,
				relation: null,
			},
			bankAccountDetails: {
				IFSC: null,
				accountHolderName: null,
				accountNumber: null,
				branch: null,
				bankName: null,
			},

			fullName: null,
			isAPISubmitting: false,
			officeEmailError: false,
			personalEmailError: false,
			personalPhoneNumberError: false,
			officePhoneNumberError: false,
			emergencyContactError: false,
			imageSrc: null,
			showUploadLogoModal: false,
		};
	}
	componentDidMount = () => {
		const json = {
			vendorId: this.props.params.vendorID,
		};
		this.getBranchList2(getBranchList);
		this.getEmployeeDefaultfilters(getEmployeeDefaultfilters);
		this.getWorkSpaceOptions(getWorkSpaceOptions, json);
		let json2 = {
			getEmployeeId: this.props.params.employeeId,
		};
		this.getEmployeeDetails2(getEmployeeDetails2, json2);
		console.log('employeedetails', this.state.employeeDetails);
		// this.setState({
		//     firstName:this.st
		// });
	};
	checkUploadLogo = async (files) => {
		const maxSize = 2 * 1024 * 1024; // 2MB
		if (files[0].size > maxSize) {
			alert(
				'File size exceeds the maximum allowed limit (2MB). Please choose a smaller file.',
			);
			return;
		}
		const reader = new FileReader();
		reader.onload = (e) => {
			this.setState({
				imageSrc: reader.result,

				showUploadLogoModal: true,
				files: files[0],
			});
		};
		reader.readAsDataURL(files[0]);
	};
	showUploadLogoModal = (e) => {
		this.setState({
			showUploadLogoModal: !this.state.showUploadLogoModal,
		});
	};
	editEmployeeAPICall = () => {
		if (this.state.isAPISubmitting === false) {
			this.setState(
				{
					isAPISubmitting: true,
				},
				() => {
					let json = {
						updateEmployeeId: this.props.params.employeeId,
						updateEmployeeInput: {
							firstName: this.state.firstName,
							lastName: this.state.lastName,
							gender: this.state.gender,
							dob: this.state.dob,
							bloodGroup: this.state.bloodGroup,
							aadharNumber: this.state.aadharNumber,
							panNumber: this.state.panNumber,
							joiningDate: this.state.joiningDate,
							department: this.state.department,
							designation: this.state.designation,
							monthlySalaryPreTax: parseFloat(this.state.monthlySalaryPreTax),
							personalPhoneNumber: this.state.personalPhoneNumber,
							personalEmail: this.state.personalEmail,
							officeEmail: this.state.officeEmail,
							officePhoneNumber: this.state.officePhoneNumber,
							currentAddress: {
								city: this.state.currentAddress.city,
								country: this.state.currentAddress.country,
								district: this.state.currentAddress.district,
								pinCode: parseInt(this.state.currentAddress.pinCode),
								state: this.state.currentAddress.state,
								street: this.state.currentAddress.street,
							},
							permanentAddress: {
								city: this.state.permanentAddress.city,
								country: this.state.permanentAddress.country,
								district: this.state.permanentAddress.district,
								pinCode: parseInt(this.state.permanentAddress.pinCode),
								state: this.state.permanentAddress.state,
								street: this.state.permanentAddress.street,
							},
							emergencyContact: {
								name: this.state.emergencyContact.name,
								phoneNumber: this.state.emergencyContact.phoneNumber,
								relation: this.state.emergencyContact.relation,
							},
							bankAccountDetails: {
								IFSC: this.state.bankAccountDetails.IFSC,
								accountHolderName: this.state.bankAccountDetails.accountHolderName,
								accountNumber: this.state.bankAccountDetails.accountNumber,
								branch: this.state.bankAccountDetails.branch,
								bankName: this.state.bankAccountDetails.bankName,
							},
							fullName: this.state.firstName + ' ' + this.state.lastName,
							// displayName: this.state.firstName + ' ' + this.state.lastName,
							employeeType: this.state.employeeTypeString,
							status: this.state.statusString,
							workspaceId: this.state.brandString,
							branch: {
								_id: this.state.branchId,
								branchId: this.state.branchIdString,
							},
						},
					};

					this.editEmployee(editEmployee, json);
					// this.props.navigate(`/${this.props.params.vendorID}/harddrives/assign`);
				},
			);
		}
	};
	onLogoUpdated = () => {
		this.setState({
			showUploadLogoModal: false,
			isLoading: true,
		});
		this.getTenantSettings();
	};
	imgCrop = (img) => {
		this.setState(
			{
				croppedFile: img,
				// imageSrc: img,
			},
			() => {
				const reader = new FileReader();
				reader.onload = (e) => {
					this.setState({
						imageSrc: reader.result,
					});
				};
				reader.readAsDataURL(img);
			},
		);
	};
	handleOnChange = (e) => {
		let name = e.target.name;
		let value = e.target.value;
		let regex = /^[0-9\b]+$/;
		console.log(regex.test(value));
		this.setState({
			[name]: regex.test(value) ? value : '',
		});
	};
	isButtonDisabled = () => {
		const {
			personalPhoneNumber,
			personalEmail,
			officeEmail,
			firstName,
			lastName,
			dob,
			aadharNumber,
			panNumber,
			joiningDate,
			department,
			designation,
			monthlySalaryPreTax,
			currentAddress,
			permanentAddress,
			emergencyContact,
			bankAccountDetails,
			personalEmailError,
			personalPhoneNumberError,
			officePhoneNumberError,
			emergencyContactError,
			officeEmailError,
			gender,
			bloodGroup,
			employeeTypeString,
			brandString,
			branchIdString,
			branchId,
			statusString,
		} = this.state;

		// Function to check if a number is valid
		const isValidNumber = (num) => {
			return num !== null && !isNaN(num);
		};

		// Perform the necessary conditions to determine if the button should be disabled
		const isDisabled =
			personalPhoneNumber === null ||
			personalPhoneNumber.length === 0 ||
			personalEmail === null ||
			personalEmail.length === 0 ||
			// officeEmail === null ||
			// officeEmail.length === 0 ||
			firstName === null ||
			firstName.length === 0 ||
			lastName === null ||
			lastName.length === 0 ||
			dob === null ||
			!isValidNumber(dob) ||
			dob.length === 0 ||
			aadharNumber === null ||
			aadharNumber.length === 0 ||
			panNumber === null ||
			panNumber.length === 0 ||
			// joiningDate === null ||
			// !isValidNumber(joiningDate) ||
			// joiningDate.length === 0 ||
			// department === null ||
			// department.length === 0 ||
			// designation === null ||
			// designation.length === 0 ||
			// monthlySalaryPreTax === null ||
			// !isValidNumber(monthlySalaryPreTax) ||
			// monthlySalaryPreTax.length === 0 ||
			currentAddress.city === null ||
			currentAddress.city.length === 0 ||
			currentAddress.country === null ||
			currentAddress.country.length === 0 ||
			currentAddress.district === null ||
			currentAddress.district.length === 0 ||
			currentAddress.pinCode === null ||
			!isValidNumber(currentAddress.pinCode) ||
			currentAddress.pinCode.length === 0 ||
			currentAddress.state === null ||
			currentAddress.state.length === 0 ||
			currentAddress.street === null ||
			currentAddress.street.length === 0 ||
			permanentAddress.city === null ||
			permanentAddress.city.length === 0 ||
			permanentAddress.country === null ||
			permanentAddress.country.length === 0 ||
			permanentAddress.district === null ||
			permanentAddress.district.length === 0 ||
			permanentAddress.pinCode === null ||
			!isValidNumber(permanentAddress.pinCode) ||
			permanentAddress.pinCode.length === 0 ||
			permanentAddress.state === null ||
			permanentAddress.state.length === 0 ||
			permanentAddress.street === null ||
			permanentAddress.street.length === 0 ||
			emergencyContact.name === null ||
			emergencyContact.name.length === 0 ||
			emergencyContact.phoneNumber === null ||
			emergencyContact.phoneNumber.length === 0 ||
			bankAccountDetails.IFSC === null ||
			bankAccountDetails.IFSC.length === 0 ||
			bankAccountDetails.accountHolderName === null ||
			bankAccountDetails.accountHolderName.length === 0 ||
			bankAccountDetails.accountNumber === null ||
			bankAccountDetails.accountNumber.length === 0 ||
			bankAccountDetails.branch === null ||
			bankAccountDetails.branch.length === 0 ||
			bankAccountDetails.bankName === null ||
			bankAccountDetails.bankName.length === 0 ||
			personalEmailError ||
			personalPhoneNumberError ||
			// officePhoneNumberError ||
			emergencyContactError ||
			// officeEmailError ||
			gender === null ||
			gender.length === 0 ||
			// bloodGroup === null ||
			// bloodGroup.length === 0 ||
			// employeeTypeString === null ||
			// employeeTypeString.length === 0 ||
			brandString === null ||
			brandString.length === 0 ||
			branchIdString === null ||
			branchIdString.length === 0 ||
			branchId === null ||
			branchId.length === 0;
		// statusString === null ||
		// statusString.length === 0

		return isDisabled;
	};
	render() {
		console.log(this.state.croppedFile, this.state.employeeId);
		console.log(this.state.employeeDetails);
		// console.log(this.state.selectedJoiningDate);
		// console.log(this.state.selectedDob);
		// console.log(this.state.joiningDate);
		// console.log(this.state.dob);
		// console.log(this.state.bankAccountDetails.accountHolderName);
		return (
			<>
				<div className="layout-wrapper">
					{/* {this.state.isLoading ? (
						<>
							<LoadingBar />
						</>
					) : ( )}*/}
					{this.state.branchesOptions.length > 0 ? (
						<div className="container">
							<div className="searchContainer">
								<a
									className="title"
									style={{
										color: '#B0B0B0',
										display: 'flex',
										alignItems: 'center',
									}}
								>
									<Back
										style={{
											cursor: 'pointer',
										}}
										onClick={() => {
											this.props.navigate(-1);
										}}
									/>
									<span
										style={{
											marginLeft: '30px',
											fontSize: '16px',
										}}
									>
										Edit Employee
									</span>
								</a>
								<button
									// className="create-shoot-btn"
									// onClick={(e) => this.toggleCreateShoot(e)}
									onClick={() => {
										this.editEmployeeAPICall();
									}}
									disabled={this.isButtonDisabled()} // Call the function to determine if the button should be disabled
									// style={{
									// 	filter: this.isButtonDisabled() ? 'blur(2px)' : 'none', // Apply blur effect when button is disabled
									// }}
									className={
										this.isButtonDisabled()
											? 'add-edit-btn disabled'
											: 'create-shoot-btn'
									}
								>
									Edit
								</button>
							</div>
							<div
								style={{
									position: 'relative',
									top: '80px',
									width: '100%',
									left: '0px',
									padding: '0px 24px',
								}}
							>
								<div
									style={{
										width: '100%',
										display: 'flex',
										// justifyContent: 'space-between',.
										gap: '20px',
									}}
								>
									<div
										style={{
											width: '20%',
											height: '30vh',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											backgroundColor: 'rgba(42, 42, 42, 0.5)',
											color: '#B0B0B0',
											borderRadius: '12px',
										}}
									>
										{/* <p
											style={{
												fontSize: '12px',
												fontWeight: '600',
												cursor: 'pointer',
											}}
										>
											Upload Profile Picture
										</p> */}
										<Dropzone
											onDrop={this.checkUploadLogo.bind(this)}
											accept={'image/jpeg'}
											multiple={false}
											// disabled={this.state.addEmployeeId.length === 0}
										>
											{({ getRootProps, getInputProps }) => (
												<div
													className="upload-brand-embeded-btn"
													{...getRootProps({})}
												>
													<input {...getInputProps()} />
													<div className="upload-brand-container-new">
														<div
															style={{
																display: 'flex',
																flexDirection: 'column',
																alignItems: 'center',
																justifyContent: 'center',
																margin: 0,
															}}
															className="upload-container f-left"
														>
															{this.state.imageSrc ? (
																<img
																	src={this.state.imageSrc}
																	style={{
																		width: '240px',
																		maxHeight: '160px',
																		objectFit: 'contain',
																	}}
																/>
															) : (
																<div className="upload-empty-text">
																	No Profile Picture selected
																</div>
															)}
														</div>
														<div className="upload">
															<span className="upload-icon">
																<UploadIcon />
															</span>
															<span className="upload-text">
																Edit Profile Picture
															</span>
														</div>
													</div>
													{/* <div className="upload-brand-btn-wrapper">
																<span className="upload-brand-btn-text">
																	+ Edit Logo
																</span>
															</div> */}
												</div>
											)}
										</Dropzone>
									</div>
									<div
										style={{
											width: '70%',
											display: 'flex',
											flexDirection: 'column',
											// alignItems:"sp"
											// justifyContent: "space-between",
											gap: '15px',
											color: '#B0B0B0',
										}}
									>
										<p
											style={{
												fontWeight: '600',
												fontSize: '12px',
												marginTop: '9px',
											}}
										>
											EMPLOYEE DETAILS
										</p>
										<div
											className="input-sec"
											// style={{
											// 	display: 'flex',
											// 	justifyContent: 'space-between',
											// }}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													First Name*{' '}
													{this.state.firstName !== null &&
														this.state.fnError &&
														this.state.firstName.length === 0 && (
															<span
																style={{
																	color: 'red',
																	marginLeft: '6px',
																}}
															>
																Required
															</span>
														)}
												</label>
												<input
													type="text"
													value={this.state.firstName}
													onChange={(e) =>
														this.setState({
															firstName: e.target.value,
														})
													}
													onBlur={(e) => {
														if (e.target.value.length === 0) {
															this.setState({
																fnError: true,
															});
														} else if (e.target.value.length > 0) {
															this.setState({
																fnError: false,
															});
														}
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														borderColor:
															this.state.firstName !== null &&
															this.state.fnError &&
															this.state.firstName.length === 0
																? 'red'
																: '#707070',
													}}
												/>
											</div>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													Last Name*{' '}
													{this.state.lastName !== null &&
														this.state.lnError &&
														this.state.lastName.length === 0 && (
															<span
																style={{
																	color: 'red',
																	marginLeft: '6px',
																}}
															>
																Required
															</span>
														)}
												</label>
												<input
													type="text"
													value={this.state.lastName}
													onChange={(e) =>
														this.setState({
															lastName: e.target.value,
														})
													}
													onBlur={(e) => {
														if (e.target.value.length === 0) {
															this.setState({
																lnError: true,
															});
														} else if (e.target.value.length > 0) {
															this.setState({
																lnError: false,
															});
														}
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														borderColor:
															this.state.lastName !== null &&
															this.state.lnError &&
															this.state.lastName.length === 0
																? 'red'
																: '#707070',
													}}
												/>
											</div>
										</div>
										<div
											className="input-sec"
											// style={{
											// 	display: 'flex',
											// 	justifyContent: 'space-between',
											// }}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>Gender*</label>
												{/* <input
													type="text"
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
													}}
												/> */}
												<Select
													required
													value={this.state.genderType}
													// onChange={this.handleChange.bind(this)}
													className="cost-select-container"
													classNamePrefix="cost-select"
													options={this.state.genderOptions}
													onChange={(e) => {
														this.setState({
															// name: e.label,
															gender: e.value,
															genderType: e,
														});
													}}
													// defaultValue={
													// 	_.filter(this.state.workspacesOptions, {
													// 		value: this.state.createShootWorkspace,
													// 	})[0]
													// }
													// value={this.state.id}
													isSearchable={true}
													menuPortalTarget={document.body}
													menuPosition={'fixed'}
												/>
											</div>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>DOB*</label>
												<input
													type="date"
													value={this.state.selectedDob}
													onChange={(e) => {
														this.setState({
															selectedDob: e.target.value,
															dob: parseInt(
																moment(e.target.value).format(
																	'YYYYMMDD',
																),
															),
														});
														console.log(
															parseInt(
																moment(e.target.value).format(
																	'YYYYMMDD',
																),
															),
														);
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														marginTop: '16px',
													}}
												/>
											</div>
										</div>
										<div
											className="input-sec"
											// style={{
											// 	display: 'flex',
											// 	justifyContent: 'space-between',
											// }}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>Blood Group</label>
												{/* <input
													type="text"
													value={this.state.bloodGroup}
													onChange={(e) =>
														this.setState({
															bloodGroup: e.target.value,
														})
													}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
													}}
												/> */}
												<Select
													required
													value={this.state.selectedBloodGroup}
													// onChange={this.handleChange.bind(this)}
													className="cost-select-container"
													classNamePrefix="cost-select"
													options={this.state.bloodGroupOptions}
													onChange={(e) => {
														this.setState({
															// name: e.label,
															bloodGroup: e.value,
															selectedBloodGroup: e,
														});
													}}
													// defaultValue={
													// 	_.filter(this.state.workspacesOptions, {
													// 		value: this.state.createShootWorkspace,
													// 	})[0]
													// }
													// value={this.state.id}
													isSearchable={true}
													menuPortalTarget={document.body}
													menuPosition={'fixed'}
												/>
											</div>
											{/* <div
											style={{
												display: 'flex',
												flexDirection: 'column',
												gap: '8px',
												fontWeight: '600',
												fontSize: '12px',
												width: '45%',
											}}
										>
											<label>Last Name</label>
											<input
												type="text"
												style={{
													// width: '45%',
													border: 'none',
													background: 'none',

													borderBottom: '1px solid #707070',
													borderRadius: '0px',
												}}
											/>
										</div> */}
										</div>
										<div
											className="input-sec"
											// style={{
											// 	display: 'flex',
											// 	justifyContent: 'space-between',
											// }}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													Adhaar*
													{this.state.aadharNumber !== null &&
														this.state.adError &&
														this.state.aadharNumber.length === 0 && (
															<span
																style={{
																	color: 'red',
																	marginLeft: '6px',
																}}
															>
																Required
															</span>
														)}
												</label>
												<input
													type="text"
													value={this.state.aadharNumber}
													onChange={(e) =>
														this.setState({
															aadharNumber: e.target.value,
														})
													}
													onBlur={(e) => {
														if (e.target.value.length === 0) {
															this.setState({
																adError: true,
															});
														} else if (e.target.value.length > 0) {
															this.setState({
																adError: false,
															});
														}
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														borderColor:
															this.state.aadharNumber !== null &&
															this.state.adError &&
															this.state.aadharNumber.length === 0
																? 'red'
																: '#707070',
													}}
												/>
											</div>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													PAN*
													{this.state.panNumber !== null &&
														this.state.panerror &&
														this.state.panNumber.length === 0 && (
															<span
																style={{
																	color: 'red',
																	marginLeft: '6px',
																}}
															>
																Required
															</span>
														)}
												</label>
												<input
													type="text"
													value={this.state.panNumber}
													onChange={(e) =>
														this.setState({
															panNumber: e.target.value,
														})
													}
													onBlur={(e) => {
														if (e.target.value.length === 0) {
															this.setState({
																panerror: true,
															});
														} else if (e.target.value.length > 0) {
															this.setState({
																panerror: false,
															});
														}
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														borderColor:
															this.state.panNumber !== null &&
															this.state.panerror &&
															this.state.panNumber.length === 0
																? 'red'
																: '#707070',
													}}
												/>
											</div>
										</div>
										<p
											style={{
												fontWeight: '600',
												fontSize: '12px',
												marginTop: '30px',
											}}
										>
											EMPLOYMENT DETAILS
										</p>
										<div
											className="input-sec"
											// style={{
											// 	display: 'flex',
											// 	justifyContent: 'space-between',
											// }}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>Joining Date</label>
												<input
													type="date"
													value={this.state.selectedJoiningDate}
													onChange={(e) =>
														this.setState({
															selectedJoiningDate: e.target.value,
															joiningDate: parseInt(
																moment(e.target.value).format(
																	'YYYYMMDD',
																),
															),
														})
													}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														marginTop: '16px',
													}}
												/>
											</div>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>Employment Type</label>
												{/* <input
												type="text"
												style={{
													// width: '45%',
													border: 'none',
													background: 'none',

													borderBottom: '1px solid #707070',
													borderRadius: '0px',
												}}
											/>
											 */}
												<Select
													required
													value={this.state.employeeType}
													// onChange={this.handleChange.bind(this)}
													className="cost-select-container"
													classNamePrefix="cost-select"
													options={this.state.empTypeOptions}
													onChange={(e) => {
														this.setState({
															// name: e.label,
															employeeTypeString: e.value,
															employeeType: e,
														});
													}}
													// defaultValue={
													// 	_.filter(this.state.workspacesOptions, {
													// 		value: this.state.createShootWorkspace,
													// 	})[0]
													// }
													// value={this.state.id}
													isSearchable={true}
													menuPortalTarget={document.body}
													menuPosition={'fixed'}
												/>
											</div>
										</div>
										<div
											className="input-sec"
											// style={{
											// 	display: 'flex',
											// 	justifyContent: 'space-between',
											// }}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>Brand*</label>
												<Select
													required
													value={this.state.selectedBrand}
													// onChange={this.handleChange.bind(this)}
													className="cost-select-container"
													classNamePrefix="cost-select"
													options={this.state.workspaceOptions}
													onChange={(e) => {
														this.setState({
															// name: e.label,
															brandString: e.value,
															selectedBrand: e,
														});
													}}
													// defaultValue={
													// 	_.filter(this.state.workspacesOptions, {
													// 		value: this.state.createShootWorkspace,
													// 	})[0]
													// }
													// value={this.state.id}
													isSearchable={true}
													menuPortalTarget={document.body}
													menuPosition={'fixed'}
												/>
											</div>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>Department</label>
												{/* <input
													type="text"
													value={this.state.department}
													onChange={(e) =>
														this.setState({
															department: e.target.value,
														})
													}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
													}}
												/> */}
												<Select
													required
													value={this.state.selectedDepartment}
													// onChange={this.handleChange.bind(this)}
													className="cost-select-container"
													classNamePrefix="cost-select"
													options={this.state.departments}
													onChange={(e) => {
														this.setState({
															// name: e.label,
															selectedDepartment: e,
															department: e.value,
														});
													}}
													isSearchable={true}
													menuPortalTarget={document.body}
													menuPosition={'fixed'}
												/>

												{/* <Select
													required
													// value={this.state.selectedValue}
													// onChange={this.handleChange.bind(this)}
													className="cost-select-container"
													classNamePrefix="cost-select"
													// options={this.state.namesList2}
													// onChange={
													// 	(e) => {
													// 		this.setState({
													// 			name: e.label,
													// 			id: e.value,
													// 			selectedValue: e,
													// 		});

													// 	}

													// }
													// defaultValue={
													// 	_.filter(this.state.workspacesOptions, {
													// 		value: this.state.createShootWorkspace,
													// 	})[0]
													// }
													// value={this.state.id}
													isSearchable={true}
												/> */}
											</div>
										</div>
										<div
											className="input-sec"
											// style={{
											// 	display: 'flex',
											// 	justifyContent: 'space-between',
											// }}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>Designation</label>
												{/* <input
													type="text"
													value={this.state.designation}
													onChange={(e) =>
														this.setState({
															designation: e.target.value,
														})
													}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
													}}
												/> */}
												<Select
													required
													value={this.state.selectedDesignation}
													// onChange={this.handleChange.bind(this)}
													className="cost-select-container"
													classNamePrefix="cost-select"
													options={this.state.designations}
													onChange={(e) => {
														this.setState({
															// name: e.label,
															designation: e.value,
															selectedDesignation: e,
														});
													}}
													isSearchable={true}
													menuPortalTarget={document.body}
													menuPosition={'fixed'}
												/>
												{/* <Select
													required
													// value={this.state.selectedValue}
													// onChange={this.handleChange.bind(this)}
													className="cost-select-container"
													classNamePrefix="cost-select"
													// options={this.state.namesList2}
													// onChange={
													// 	(e) => {
													// 		this.setState({
													// 			name: e.label,
													// 			id: e.value,
													// 			selectedValue: e,
													// 		});

													// 	}

													// }
													// defaultValue={
													// 	_.filter(this.state.workspacesOptions, {
													// 		value: this.state.createShootWorkspace,
													// 	})[0]
													// }
													// value={this.state.id}
													isSearchable={true}
												/> */}
											</div>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>Monthly Salary</label>
												<input
													type="number"
													value={this.state.monthlySalaryPreTax}
													onChange={(e) =>
														this.setState({
															monthlySalaryPreTax: e.target.value,
														})
													}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														marginTop: '16px',
													}}
												/>
											</div>
										</div>
										<div
											className="input-sec"
											// style={{
											// 	display: 'flex',
											// 	justifyContent: 'space-between',
											// }}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>Branch*</label>
												<Select
													required
													value={this.state.selectedBranch}
													// onChange={this.handleChange.bind(this)}
													className="cost-select-container"
													classNamePrefix="cost-select"
													options={this.state.branchesOptions}
													onChange={(e) => {
														this.setState({
															branchIdString: e.label,
															branchId: e.value,
															selectedBranch: e,
														});
													}}
													// defaultValue={
													// 	_.filter(this.state.workspacesOptions, {
													// 		value: this.state.createShootWorkspace,
													// 	})[0]
													// }
													// value={this.state.id}
													isSearchable={true}
													menuPortalTarget={document.body}
													menuPosition={'fixed'}
												/>
											</div>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>Status</label>
												{/* <input
												type="text"
												style={{
													// width: '45%',
													border: 'none',
													background: 'none',

													borderBottom: '1px solid #707070',
													borderRadius: '0px',
												}}
											/>
											 */}
												<Select
													required
													value={this.state.selectedStatus}
													// onChange={this.handleChange.bind(this)}
													className="cost-select-container"
													classNamePrefix="cost-select"
													options={this.state.statusOptions}
													onChange={(e) => {
														this.setState({
															statusString: e.value,
															selectedStatus: e,
														});
													}}
													// defaultValue={
													// 	_.filter(this.state.workspacesOptions, {
													// 		value: this.state.createShootWorkspace,
													// 	})[0]
													// }
													// value={this.state.id}
													isSearchable={true}
													menuPortalTarget={document.body}
													menuPosition={'fixed'}
												/>
											</div>
										</div>
										<p
											style={{
												fontWeight: '600',
												fontSize: '12px',
												marginTop: '30px',
											}}
										>
											CONTACT DETAILS
										</p>
										<div
											className="input-sec"
											// style={{
											// 	display: 'flex',
											// 	justifyContent: 'space-between',
											// }}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													Phone*
													{this.state.personalPhoneNumber &&
													this.state.personalPhoneNumberError &&
													this.state.personalPhoneNumber.length > 0 ? (
														<span
															style={{
																color: 'red',
																marginLeft: '6px',
															}}
														>
															Wrong format for Phone Number
														</span>
													) : this.state.personalPhoneNumber !== null &&
													  this.state.personalPhoneNumberError &&
													  this.state.personalPhoneNumber.length ===
															0 ? (
														<span
															style={{
																color: 'red',
																marginLeft: '6px',
															}}
														>
															Required
														</span>
													) : (
														<></>
													)}
												</label>
												<input
													type="text"
													value={this.state.personalPhoneNumber}
													// onChange={(e) => {
													// 	this.setState({
													// 		personalPhoneNumber: e.target.value,
													// 	});
													// }}
													name={'personalPhoneNumber'}
													onChange={(e) => this.handleOnChange(e)}
													onBlur={(e) => {
														if (
															!validator.isMobilePhone(
																e.target.value,
																'en-IN',
															)
														) {
															this.setState({
																personalPhoneNumberError: true,
															});
														} else {
															this.setState({
																personalPhoneNumberError: false,
															});
														}
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														borderColor:
															(this.state.personalPhoneNumber &&
																this.state
																	.personalPhoneNumberError &&
																this.state.personalPhoneNumber
																	.length > 0) ||
															(this.state.personalPhoneNumber !==
																null &&
																this.state
																	.personalPhoneNumberError &&
																this.state.personalPhoneNumber
																	.length === 0)
																? 'red'
																: '#707070',
													}}
												/>
											</div>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													Email*
													{this.state.personalEmail &&
													this.state.personalEmailError &&
													this.state.personalEmail.length > 0 ? (
														<span
															style={{
																color: 'red',
																marginLeft: '6px',
															}}
														>
															Wrong email format
														</span>
													) : this.state.personalEmail !== null &&
													  this.state.personalEmailError &&
													  this.state.personalEmail.length === 0 ? (
														<span
															style={{
																color: 'red',
																marginLeft: '6px',
															}}
														>
															Required
														</span>
													) : (
														<></>
													)}
												</label>
												<input
													type="text"
													value={this.state.personalEmail}
													onChange={(e) => {
														this.setState({
															personalEmail: e.target.value,
														});
													}}
													onBlur={(e) => {
														if (!validator.isEmail(e.target.value)) {
															this.setState({
																personalEmailError: true,
															});
														} else {
															this.setState({
																personalEmailError: false,
															});
														}
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														borderColor:
															(this.state.personalEmail &&
																this.state.personalEmailError &&
																this.state.personalEmail.length >
																	0) ||
															(this.state.personalEmail !== null &&
																this.state.personalEmailError &&
																this.state.personalEmail.length ===
																	0)
																? 'red'
																: '#707070',
													}}
												/>
											</div>
										</div>
										<div
											className="input-sec"
											// style={{
											// 	display: 'flex',
											// 	justifyContent: 'space-between',
											// }}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													Office phone
													{this.state.officePhoneNumber &&
													this.state.officePhoneNumberError &&
													this.state.officePhoneNumber.length > 0 ? (
														<span
															style={{
																color: 'red',
																marginLeft: '6px',
															}}
														>
															Wrong format for Phone Number
														</span>
													) : this.state.officePhoneNumber !== null &&
													  this.state.officePhoneNumberError &&
													  this.state.officePhoneNumber.length === 0 ? (
														<span
															style={{
																color: 'red',
																marginLeft: '6px',
															}}
														>
															Required
														</span>
													) : (
														<></>
													)}
												</label>
												<input
													type="text"
													value={this.state.officePhoneNumber}
													// onChange={(e) => {
													// 	this.setState({
													// 		officePhoneNumber: e.target.value,
													// 	});
													// }}
													name={'officePhoneNumber'}
													onChange={(e) => this.handleOnChange(e)}
													onBlur={(e) => {
														if (
															!validator.isMobilePhone(
																e.target.value,
																'en-IN',
															)
														) {
															this.setState({
																officePhoneNumberError: true,
															});
														} else {
															this.setState({
																officePhoneNumberError: false,
															});
														}
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														borderColor:
															(this.state.officePhoneNumber &&
																this.state.officePhoneNumberError &&
																this.state.officePhoneNumber
																	.length > 0) ||
															(this.state.officePhoneNumber !==
																null &&
																this.state.officePhoneNumberError &&
																this.state.officePhoneNumber
																	.length === 0)
																? 'red'
																: '#707070',
													}}
												/>
											</div>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													Office email{' '}
													{this.state.officeEmail &&
													this.state.officeEmailError &&
													this.state.officeEmail.length > 0 ? (
														<span
															style={{
																color: 'red',
																marginLeft: '6px',
															}}
														>
															Wrong email format
														</span>
													) : this.state.officeEmail !== null &&
													  this.state.officeEmailError &&
													  this.state.officeEmail.length === 0 ? (
														<span
															style={{
																color: 'red',
																marginLeft: '6px',
															}}
														>
															Required
														</span>
													) : (
														<></>
													)}
												</label>
												<input
													type="text"
													value={this.state.officeEmail}
													onChange={(e) => {
														this.setState({
															officeEmail: e.target.value,
														});
													}}
													onBlur={(e) => {
														if (!validator.isEmail(e.target.value)) {
															this.setState({
																officeEmailError: true,
															});
														} else {
															this.setState({
																officeEmailError: false,
															});
														}
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														borderColor:
															(this.state.officeEmail &&
																this.state.officeEmailError &&
																this.state.officeEmail.length >
																	0) ||
															(this.state.officeEmail !== null &&
																this.state.officeEmailError &&
																this.state.officeEmail.length === 0)
																? 'red'
																: '#707070',
													}}
												/>
											</div>
										</div>
										<p
											style={{
												fontWeight: '600',
												fontSize: '12px',
												// marginTop: '30px',
											}}
										>
											CURRENT ADDRESS
										</p>
										<div
											className="input-sec"
											// style={{
											// 	display: 'flex',
											// 	justifyContent: 'space-between',
											// }}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													City*{' '}
													{this.state.currentAddress.city !== null &&
														this.state.curcityEr &&
														this.state.currentAddress.city.length ===
															0 && (
															<span
																style={{
																	color: 'red',
																	marginLeft: '6px',
																}}
															>
																Required
															</span>
														)}
												</label>
												<input
													type="text"
													value={this.state.currentAddress.city}
													onChange={(e) => {
														this.setState({
															currentAddress: {
																...this.state.currentAddress,
																city: e.target.value,
															},
														});
													}}
													onBlur={(e) => {
														if (e.target.value.length === 0) {
															this.setState({
																curcityEr: true,
															});
														} else if (e.target.value.length > 0) {
															this.setState({
																curcityEr: false,
															});
														}
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														borderColor:
															this.state.currentAddress.city !==
																null &&
															this.state.curcityEr &&
															this.state.currentAddress.city
																.length === 0
																? 'red'
																: '#707070',
													}}
												/>
											</div>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													Country*
													{this.state.currentAddress.country !== null &&
														this.state.curcountryEr &&
														this.state.currentAddress.country.length ===
															0 && (
															<span
																style={{
																	color: 'red',
																	marginLeft: '6px',
																}}
															>
																Required
															</span>
														)}
												</label>
												<input
													type="text"
													value={this.state.currentAddress.country}
													onChange={(e) => {
														this.setState({
															currentAddress: {
																...this.state.currentAddress,
																country: e.target.value,
															},
														});
													}}
													onBlur={(e) => {
														if (e.target.value.length === 0) {
															this.setState({
																curcountryEr: true,
															});
														} else if (e.target.value.length > 0) {
															this.setState({
																curcountryEr: false,
															});
														}
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														borderColor:
															this.state.currentAddress.country !==
																null &&
															this.state.curcountryEr &&
															this.state.currentAddress.country
																.length === 0
																? 'red'
																: '#707070',
													}}
												/>
											</div>
										</div>
										<div
											className="input-sec"
											// style={{
											// 	display: 'flex',
											// 	justifyContent: 'space-between',
											// }}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													District*{' '}
													{this.state.currentAddress.district !== null &&
														this.state.curDistrictEr &&
														this.state.currentAddress.district
															.length === 0 && (
															<span
																style={{
																	color: 'red',
																	marginLeft: '6px',
																}}
															>
																Required
															</span>
														)}
												</label>
												<input
													type="text"
													value={this.state.currentAddress.district}
													onChange={(e) => {
														this.setState({
															currentAddress: {
																...this.state.currentAddress,
																district: e.target.value,
															},
														});
													}}
													onBlur={(e) => {
														if (e.target.value.length === 0) {
															this.setState({
																curDistrictEr: true,
															});
														} else if (e.target.value.length > 0) {
															this.setState({
																curDistrictEr: false,
															});
														}
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														borderColor:
															this.state.currentAddress.district !==
																null &&
															this.state.curDistrictEr &&
															this.state.currentAddress.district
																.length === 0
																? 'red'
																: '#707070',
													}}
												/>
											</div>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													Pincode*
													{this.state.currentAddress.pinCode !== null &&
														this.state.curPcEr &&
														this.state.currentAddress.pinCode.length ===
															0 && (
															<span
																style={{
																	color: 'red',
																	marginLeft: '6px',
																}}
															>
																Required
															</span>
														)}
												</label>
												<input
													type="number"
													value={this.state.currentAddress.pinCode}
													onChange={(e) => {
														this.setState({
															currentAddress: {
																...this.state.currentAddress,
																pinCode: e.target.value,
															},
														});
													}}
													onBlur={(e) => {
														if (e.target.value.length === 0) {
															this.setState({
																curPcEr: true,
															});
														} else if (e.target.value.length > 0) {
															this.setState({
																curPcEr: false,
															});
														}
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														marginTop: '16px',
														borderColor:
															this.state.currentAddress.pinCode !==
																null &&
															this.state.curPcEr &&
															this.state.currentAddress.pinCode
																.length === 0
																? 'red'
																: '#707070',
													}}
												/>
											</div>
										</div>
										<div
											className="input-sec"
											// style={{
											// 	display: 'flex',
											// 	justifyContent: 'space-between',
											// }}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													State*
													{this.state.currentAddress.state !== null &&
														this.state.curStateEr &&
														this.state.currentAddress.state.length ===
															0 && (
															<span
																style={{
																	color: 'red',
																	marginLeft: '6px',
																}}
															>
																Required
															</span>
														)}
												</label>
												<input
													type="text"
													value={this.state.currentAddress.state}
													onChange={(e) => {
														this.setState({
															currentAddress: {
																...this.state.currentAddress,
																state: e.target.value,
															},
														});
													}}
													onBlur={(e) => {
														if (e.target.value.length === 0) {
															this.setState({
																curStateEr: true,
															});
														} else if (e.target.value.length > 0) {
															this.setState({
																curStateEr: false,
															});
														}
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														borderColor:
															this.state.currentAddress.state !==
																null &&
															this.state.curStateEr &&
															this.state.currentAddress.state
																.length === 0
																? 'red'
																: '#707070',
													}}
												/>
											</div>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													Street*
													{this.state.currentAddress.street !== null &&
														this.state.curStreetEr &&
														this.state.currentAddress.street.length ===
															0 && (
															<span
																style={{
																	color: 'red',
																	marginLeft: '6px',
																}}
															>
																Required
															</span>
														)}
												</label>
												<input
													type="text"
													value={this.state.currentAddress.street}
													onChange={(e) => {
														this.setState({
															currentAddress: {
																...this.state.currentAddress,
																street: e.target.value,
															},
														});
													}}
													onBlur={(e) => {
														if (e.target.value.length === 0) {
															this.setState({
																curStateEr: true,
															});
														} else if (e.target.value.length > 0) {
															this.setState({
																curStateEr: false,
															});
														}
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														borderColor:
															this.state.currentAddress.street !==
																null &&
															this.state.curStreetEr &&
															this.state.currentAddress.street
																.length === 0
																? 'red'
																: '#707070',
													}}
												/>
											</div>
										</div>
										<p
											style={{
												fontWeight: '600',
												fontSize: '12px',
												// marginTop: '30px',
											}}
										>
											PERMANENT ADDRESS
										</p>
										<div
											className="input-sec"
											// style={{
											// 	display: 'flex',
											// 	justifyContent: 'space-between',
											// }}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													City*
													{this.state.permanentAddress.city !== null &&
														this.state.percityEr &&
														this.state.permanentAddress.city.length ===
															0 && (
															<span
																style={{
																	color: 'red',
																	marginLeft: '6px',
																}}
															>
																Required
															</span>
														)}
												</label>
												<input
													type="text"
													value={this.state.permanentAddress.city}
													onChange={(e) => {
														this.setState({
															permanentAddress: {
																...this.state.permanentAddress,
																city: e.target.value,
															},
														});
													}}
													onBlur={(e) => {
														if (e.target.value.length === 0) {
															this.setState({
																percityEr: true,
															});
														} else if (e.target.value.length > 0) {
															this.setState({
																percityEr: false,
															});
														}
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														borderColor:
															this.state.permanentAddress.city !==
																null &&
															this.state.percityEr &&
															this.state.permanentAddress.city
																.length === 0
																? 'red'
																: '#707070',
													}}
												/>
											</div>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													Country*{' '}
													{this.state.permanentAddress.country !== null &&
														this.state.percountryEr &&
														this.state.permanentAddress.country
															.length === 0 && (
															<span
																style={{
																	color: 'red',
																	marginLeft: '6px',
																}}
															>
																Required
															</span>
														)}{' '}
												</label>
												<input
													type="text"
													value={this.state.permanentAddress.country}
													onChange={(e) => {
														this.setState({
															permanentAddress: {
																...this.state.permanentAddress,
																country: e.target.value,
															},
														});
													}}
													onBlur={(e) => {
														if (e.target.value.length === 0) {
															this.setState({
																percountryEr: true,
															});
														} else if (e.target.value.length > 0) {
															this.setState({
																percountryEr: false,
															});
														}
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														bordercolor:
															this.state.permanentAddress.country !==
																null &&
															this.state.percountryEr &&
															this.state.permanentAddress.country
																.length === 0
																? 'red'
																: '#707070',
													}}
												/>
											</div>
										</div>
										<div
											className="input-sec"
											// style={{
											// 	display: 'flex',
											// 	justifyContent: 'space-between',
											// }}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													District*{' '}
													{this.state.permanentAddress.district !==
														null &&
														this.state.perDistrictEr &&
														this.state.permanentAddress.district
															.length === 0 && (
															<span
																style={{
																	color: 'red',
																	marginLeft: '6px',
																}}
															>
																Required
															</span>
														)}
												</label>
												<input
													type="text"
													value={this.state.permanentAddress.district}
													onChange={(e) => {
														this.setState({
															permanentAddress: {
																...this.state.permanentAddress,
																district: e.target.value,
															},
														});
													}}
													onBlur={(e) => {
														if (e.target.value.length === 0) {
															this.setState({
																perDistrictEr: true,
															});
														} else if (e.target.value.length > 0) {
															this.setState({
																perDistrictEr: false,
															});
														}
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														borderColor:
															this.state.permanentAddress.district !==
																null &&
															this.state.perDistrictEr &&
															this.state.permanentAddress.district
																.length === 0
																? 'red'
																: '#707070',
													}}
												/>
											</div>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													Pincode*
													{this.state.permanentAddress.pinCode !== null &&
														this.state.perPcEr &&
														this.state.permanentAddress.pinCode
															.length === 0 && (
															<span
																style={{
																	color: 'red',
																	marginLeft: '6px',
																}}
															>
																Required
															</span>
														)}
												</label>
												<input
													type="number"
													value={this.state.permanentAddress.pinCode}
													onChange={(e) => {
														this.setState({
															permanentAddress: {
																...this.state.permanentAddress,
																pinCode: e.target.value,
															},
														});
													}}
													onBlur={(e) => {
														if (e.target.value.length === 0) {
															this.setState({
																perPcEr: true,
															});
														} else if (e.target.value.length > 0) {
															this.setState({
																perPcEr: false,
															});
														}
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														marginTop: '16px',
														borderColor:
															this.state.permanentAddress.pinCode !==
																null &&
															this.state.perPcEr &&
															this.state.permanentAddress.pinCode
																.length === 0
																? 'red'
																: '#707070',
													}}
												/>
											</div>
										</div>
										<div
											className="input-sec"
											// style={{
											// 	display: 'flex',
											// 	justifyContent: 'space-between',
											// }}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													State*
													{this.state.permanentAddress.state !== null &&
														this.state.perStateEr &&
														this.state.permanentAddress.state.length ===
															0 && (
															<span
																style={{
																	color: 'red',
																	marginLeft: '6px',
																}}
															>
																Required
															</span>
														)}
												</label>
												<input
													type="text"
													value={this.state.permanentAddress.state}
													onChange={(e) => {
														this.setState({
															permanentAddress: {
																...this.state.permanentAddress,
																state: e.target.value,
															},
														});
													}}
													onBlur={(e) => {
														if (e.target.value.length === 0) {
															this.setState({
																perStateEr: true,
															});
														} else if (e.target.value.length > 0) {
															this.setState({
																perStateEr: false,
															});
														}
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														bordercolor:
															this.state.permanentAddress.state !==
																null &&
															this.state.perStateEr &&
															this.state.permanentAddress.state
																.length === 0
																? 'red'
																: '#707070',
													}}
												/>
											</div>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													Street*{' '}
													{this.state.permanentAddress.street !== null &&
														this.state.perStreetEr &&
														this.state.permanentAddress.street
															.length === 0 && (
															<span
																style={{
																	color: 'red',
																	marginLeft: '6px',
																}}
															>
																Required
															</span>
														)}
												</label>
												<input
													type="text"
													value={this.state.permanentAddress.street}
													onChange={(e) => {
														this.setState({
															permanentAddress: {
																...this.state.permanentAddress,
																street: e.target.value,
															},
														});
													}}
													onBlur={(e) => {
														if (e.target.value.length === 0) {
															this.setState({
																perStreetEr: true,
															});
														} else if (e.target.value.length > 0) {
															this.setState({
																perStreetEr: false,
															});
														}
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														borderColor:
															this.state.permanentAddress.street !==
																null &&
															this.state.perStreetEr &&
															this.state.permanentAddress.street
																.length === 0
																? 'red'
																: '#707070',
													}}
												/>
											</div>
										</div>
										<p
											style={{
												fontWeight: '600',
												fontSize: '12px',
												// marginTop: '30px',
											}}
										>
											EMERGENCY CONTACT
										</p>
										<div
											className="input-sec"
											// style={{
											// 	display: 'flex',
											// 	justifyContent: 'space-between',
											// }}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													Name*
													{this.state.emergencyContact.name !== null &&
														this.state.emergencyNameError &&
														this.state.emergencyContact.name.length ===
															0 && (
															<span
																style={{
																	color: 'red',
																	marginLeft: '6px',
																}}
															>
																Required
															</span>
														)}
												</label>
												<input
													type="text"
													value={this.state.emergencyContact.name}
													onChange={(e) => {
														this.setState({
															emergencyContact: {
																...this.state.emergencyContact,
																name: e.target.value,
															},
														});
													}}
													onBlur={(e) => {
														if (e.target.value.length === 0) {
															this.setState({
																emergencyNameError: true,
															});
														} else if (e.target.value.length > 0) {
															this.setState({
																emergencyNameError: false,
															});
														}
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														bordercolor:
															this.state.emergencyContact.name !==
																null &&
															this.state.emergencyNameError &&
															this.state.emergencyContact.name
																.length === 0
																? 'red'
																: '#707070',
													}}
												/>
											</div>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													Phone Number*
													{this.state.emergencyContact.phoneNumber &&
													this.state.emergencyContactError &&
													this.state.emergencyContact.phoneNumber.length >
														0 ? (
														<span
															style={{
																color: 'red',
																marginLeft: '6px',
															}}
														>
															Wrong format for Phone Number
														</span>
													) : this.state.emergencyContact.phoneNumber !==
															null &&
													  this.state.emergencyContactError &&
													  this.state.emergencyContact.phoneNumber
															.length === 0 ? (
														<span
															style={{
																color: 'red',
																marginLeft: '6px',
															}}
														>
															Required
														</span>
													) : (
														<></>
													)}
												</label>
												<input
													type="text"
													value={this.state.emergencyContact.phoneNumber}
													onChange={(e) => {
														this.setState({
															emergencyContact: {
																...this.state.emergencyContact,
																phoneNumber: e.target.value,
															},
														});
													}}
													onBlur={(e) => {
														if (
															!validator.isMobilePhone(
																e.target.value,
																'en-IN',
															)
														) {
															this.setState({
																emergencyContactError: true,
															});
														} else {
															this.setState({
																emergencyContactError: false,
															});
														}
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														borderColor:
															(this.state.emergencyContact
																.phoneNumber &&
																this.state.emergencyContactError &&
																this.state.emergencyContact
																	.phoneNumber.length > 0) ||
															(this.state.emergencyContact
																.phoneNumber !== null &&
																this.state.emergencyContactError &&
																this.state.emergencyContact
																	.phoneNumber.length === 0)
																? 'red'
																: '#707070',
													}}
												/>
											</div>
										</div>
										<div
											className="input-sec"
											// style={{
											// 	display: 'flex',
											// 	justifyContent: 'space-between',
											// }}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>Relation</label>
												<input
													type="text"
													value={this.state.emergencyContact.relation}
													onChange={(e) => {
														this.setState({
															emergencyContact: {
																...this.state.emergencyContact,
																relation: e.target.value,
															},
														});
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
													}}
												/>
											</div>
											{/* <div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '600',
													fontSize: '12px',
													width: '45%',
												}}
											>
												<label>Phone Number</label>
												<input
													type="text"
													value={this.state.emergencyContact.phoneNumber}
													onChange={(e) => {
														this.setState({
															emergencyContact: {
																...this.state.emergencyContact,
																phoneNumber: e.target.value,
															},
														});
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
													}}
												/>
											</div> */}
										</div>
										<p
											style={{
												fontWeight: '600',
												fontSize: '12px',
												marginTop: '30px',
											}}
										>
											BANK DETAILS
										</p>
										<div
											className="input-sec"
											// style={{
											// 	display: 'flex',
											// 	justifyContent: 'space-between',
											// }}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													IFSC*
													{this.state.bankAccountDetails.IFSC !== null &&
														this.state.bankifscEr &&
														this.state.bankAccountDetails.IFSC
															.length === 0 && (
															<span
																style={{
																	color: 'red',
																	marginLeft: '6px',
																}}
															>
																Required
															</span>
														)}
												</label>
												<input
													type="text"
													value={this.state.bankAccountDetails.IFSC}
													onChange={(e) => {
														this.setState({
															bankAccountDetails: {
																...this.state.bankAccountDetails,
																IFSC: e.target.value,
															},
														});
													}}
													onBlur={(e) => {
														if (e.target.value.length === 0) {
															this.setState({
																bankifscEr: true,
															});
														} else if (e.target.value.length > 0) {
															this.setState({
																bankifscEr: false,
															});
														}
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														borderColor:
															this.state.bankAccountDetails.IFSC !==
																null &&
															this.state.bankifscEr &&
															this.state.bankAccountDetails.IFSC
																.length === 0
																? 'red'
																: '#707070',
													}}
												/>
											</div>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													Account Holder Name*
													{this.state.bankAccountDetails
														.accountHolderName !== null &&
														this.state.bankAccHolErr &&
														this.state.bankAccountDetails
															.accountHolderName.length === 0 && (
															<span
																style={{
																	color: 'red',
																	marginLeft: '6px',
																}}
															>
																Required
															</span>
														)}
												</label>
												<input
													type="text"
													value={
														this.state.bankAccountDetails
															.accountHolderName
													}
													onBlur={(e) => {
														if (e.target.value.length === 0) {
															this.setState({
																bankAccHolErr: true,
															});
														} else if (e.target.value.length > 0) {
															this.setState({
																bankAccHolErr: false,
															});
														}
													}}
													onChange={(e) => {
														this.setState({
															bankAccountDetails: {
																...this.state.bankAccountDetails,
																accountHolderName: e.target.value,
															},
														});
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														borderColor:
															this.state.bankAccountDetails
																.accountHolderName !== null &&
															this.state.bankAccHolErr &&
															this.state.bankAccountDetails
																.accountHolderName.length === 0
																? 'red'
																: '#707070',
													}}
												/>
											</div>
										</div>
										<div
											className="input-sec"
											// style={{
											// 	display: 'flex',
											// 	justifyContent: 'space-between',
											// }}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													Account Number*
													{this.state.bankAccountDetails.accountNumber !==
														null &&
														this.state.bankAccNumberError &&
														this.state.bankAccountDetails.accountNumber
															.length === 0 && (
															<span
																style={{
																	color: 'red',
																	marginLeft: '6px',
																}}
															>
																Required
															</span>
														)}
												</label>
												<input
													type="text"
													value={
														this.state.bankAccountDetails.accountNumber
													}
													onChange={(e) => {
														this.setState({
															bankAccountDetails: {
																...this.state.bankAccountDetails,
																accountNumber: e.target.value,
															},
														});
													}}
													onBlur={(e) => {
														if (e.target.value.length === 0) {
															this.setState({
																bankAccNumberError: true,
															});
														} else if (e.target.value.length > 0) {
															this.setState({
																bankAccNumberError: false,
															});
														}
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														borderColor:
															this.state.bankAccountDetails
																.accountNumber !== null &&
															this.state.bankAccNumberError &&
															this.state.bankAccountDetails
																.accountNumber.length === 0
																? 'red'
																: '#707070',
													}}
												/>
											</div>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													Branch*
													{this.state.bankAccountDetails.branch !==
														null &&
														this.state.bankBranchError &&
														this.state.bankAccountDetails.branch
															.length === 0 && (
															<span
																style={{
																	color: 'red',
																	marginLeft: '6px',
																}}
															>
																Required
															</span>
														)}
												</label>
												<input
													type="text"
													value={this.state.bankAccountDetails.branch}
													onChange={(e) => {
														this.setState({
															bankAccountDetails: {
																...this.state.bankAccountDetails,
																branch: e.target.value,
															},
														});
													}}
													onBlur={(e) => {
														if (e.target.value.length === 0) {
															this.setState({
																bankBranchError: true,
															});
														} else if (e.target.value.length > 0) {
															this.setState({
																bankBranchError: false,
															});
														}
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														marginTop: '16px',
														borderColor:
															this.state.bankAccountDetails.branch !==
																null &&
															this.state.bankBranchError &&
															this.state.bankAccountDetails.branch
																.length === 0
																? 'red'
																: '#707070',
													}}
												/>
											</div>
										</div>
										<div
											className="input-sec"
											// style={{
											// 	display: 'flex',
											// 	justifyContent: 'space-between',
											// }}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '400',
													fontSize: '13px',
													width: '45%',
												}}
											>
												<label>
													Bank Name*
													{this.state.bankAccountDetails.bankName !==
														null &&
														this.state.bankNameError &&
														this.state.bankAccountDetails.bankName
															.length === 0 && (
															<span
																style={{
																	color: 'red',
																	marginLeft: '6px',
																}}
															>
																Required
															</span>
														)}
												</label>
												<input
													type="text"
													value={this.state.bankAccountDetails.bankName}
													onChange={(e) => {
														this.setState({
															bankAccountDetails: {
																...this.state.bankAccountDetails,
																bankName: e.target.value,
															},
														});
													}}
													onBlur={(e) => {
														if (e.target.value.length === 0) {
															this.setState({
																bankNameError: true,
															});
														} else if (e.target.value.length > 0) {
															this.setState({
																bankNameError: false,
															});
														}
													}}
													style={{
														// width: '45%',
														border: 'none',
														background: 'none',

														borderBottom: '1px solid #707070',
														borderRadius: '0px',
														borderColor:
															this.state.bankAccountDetails
																.bankName !== null &&
															this.state.bankNameError &&
															this.state.bankAccountDetails.bankName
																.length === 0
																? 'red'
																: '#707070',
													}}
												/>
											</div>
											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '8px',
													fontWeight: '600',
													fontSize: '12px',
													width: '45%',
												}}
											>
												{/* <label>Street</label>
											<input
												type="text"
												style={{
													// width: '45%',
													border: 'none',
													background: 'none',

													borderBottom: '1px solid #707070',
													borderRadius: '0px',
												}}
											/> */}
											</div>
										</div>
										<div
											style={{
												height: '40px',
											}}
										></div>
									</div>
								</div>
							</div>
						</div>
					) : (
						<>
							<LoadingBar />
						</>
					)}
					<Modal
						handleClose={() => this.showUploadLogoModal()}
						show={this.state.showUploadLogoModal}
						modalType={'center'}
					>
						<UploadLogoForm
							{...this.props}
							imageSrc={this.state.imageSrc}
							addEmployeeId={this.state.addEmployeeId}
							files={this.state.files}
							imageHeight={this.state.imageHeight}
							imageWidth={this.state.imageWidth}
							close={() => this.showUploadLogoModal()}
							onLogoUpdated={() => this.onLogoUpdated()}
							imgCrop={(img) => {
								this.imgCrop(img);
							}}
						/>
					</Modal>
				</div>
			</>
		);
	}
}
export default withRouter(EditEmployee);
